export const shouldVerifyInput = (
    originalVal: string | undefined,
    newVal: string | undefined,
    hasBeenConfirmed: boolean | undefined,
): boolean => {
    const inputHasChanged = (newVal: string | undefined, originalVal: string | undefined) =>
        newVal && newVal !== originalVal;

    if (!hasBeenConfirmed) {
        return true;
    }

    if (inputHasChanged(newVal, originalVal)) {
        return true;
    } else {
        return false;
    }
};
